export const BASE_URL = "https://admin.xder.app:4000/";
// export const BASE_URL = "http://192.168.1.10:4000/";


// Auth :
export const loginAPI = "admin/login";
export const signupAPI = "admin/register";

export const forgotPasswordAPI = "admin/forgot-password";
export const changePasswordAPI = "admin/change-password";

// Profile :
export const profileAPI = "admin/profile";
export const profileUpdateAPI = "admin/profile/update";

// User :

export const usersAPI = "admin/get-all-users";
export const userDetailAPI = "admin/get-user-by-id";
export const deleteUsersAPI = "admin/delete-user";

export const blockUnblockedUserAPI = "admin/user-block-unblock";
export const filterUserAPI = "admin/get-all-filtered-users";

export const dashboardAPI = "admin/dashboard-data";

// Subcriptions
export const getAllSubscriptionAPI = "admin/get-all-subscriptions";
export const filterSubscriptionAPI = "admin/get-all-subscriptions";

// user reports
export const getAllReportsAPI = "admin/get-all-reports";
export const BlockUnblockReportAPI = "admin//user-block-unblock";

//Groups
export const getAllFirebaseGroupAPI = "firebase/get-all-firebase-groups";
export const firebaseRemoveUserFromGroupAPI = "firebase/remove-user-from-group";

//varification
export const getVarificationDataAPI = "admin/get-verification-data";
export const verifyUserAPI = "admin/verify-user";

export const RejectUserEndPointURL = "admin/reject-facial-verification";

// group reports
export const getAllGroupReportsAPI = "admin/get-all-group-reports";
export const DeleteGroupReportAPI = "admin/delete-group";

// Warning
export const sendWarningToUserEndPointURL = "admin/send-warning-to-user";
export const BlockToGroupAdminEndPointURL = "admin/send-warning-to-user";

// Notification
export const getAllSentNotificationEndPointURL = "admin/get-all-sent-notifications";
export const getAllScheduleNotificationEndPointURL = "admin/get-all-schedule-notifications";

export const getAllNotificationEndPointURL = "admin/get-all-notifications";
export const sentNotificationEndPointURL = "admin/create-notification";

export const deleteNotificationEndPointURL = "admin/delete-notification/"
export const updateNotificationEndPointURL = "admin/update-notification"

export const notificationDetailAPI = "admin/get-notification-metrics-by-notification-id"

export  const groupStatusToggleAPI = "admin/group-block-unblock"